import { useQuery } from "@tanstack/react-query";

import Axios from "@/lib/axios-instance";

export const getFilteredLogs = async (status: number | null) => {
    try {
        const response = await Axios.get(`/chat_logs/store/filter?status=${status}`);
        return response.data;
    } catch (error: any) {
        if (error.response) {
            throw new Error(`${error.response.data?.meta?.message || "An error occurred"}`);
        }
        throw new Error(error.message || "Network Error");
    }
};

export const useGetFilteredLogs = ({ enabled, status }: { enabled: boolean; status: number | null }) => {
    const sessions = useQuery({
        queryKey: ["get_filtered_logs", status],
        queryFn: () => getFilteredLogs(status),
        enabled,
    });

    return sessions;
};
